<template>
  <div
    v-if="valeurs != null"
    class="d-flex justify-center"
    :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
  >
    <div
      class="intro white--text"
      :class="$vuetify.breakpoint.mobile ? 'pl-3 pb-2' : 'pl-2 fixed-width'"
    >
      {{ libelle }}
    </div>
    <div class="d-flex">
      <template v-for="colonne in colonnesVisibles">
        <div
          v-if="!enChargement(colonne)"
          :key="colonne"
          class="titre-h4 white--text fixed-width align-center"
        >
          {{ valeurAffichee(colonne) | roundNumber(0) }}
        </div>
        <div
          v-else
          :key="colonne + '-chargement'"
          class="fixed-width align-center"
        >
          <v-progress-circular
            indeterminate
            size="18"
            color="white"
          />
        </div>
      </template>
    </div>
  </div>
</template>
<script>
/*
 * Bandeau de totaux par culture comparee.
 *
 * Le meme bloc figurait cinq fois dans l'ecran du comparateur - total des
 * produits, total des intrants, total des charges specifiques et marge brute
 * (deux fois) - recopie colonne par colonne, soit une quarantaine de lignes
 * a chaque fois pour un comportement identique :
 *
 *   - un rond de progression tant que la colonne se recalcule ;
 *   - un tiret si la colonne est en erreur de saisie, ou si le total vaut 0 ;
 *   - la valeur arrondie sinon.
 *
 * La troisieme colonne est masquee en vue mobile, ou seules deux cultures
 * sont comparees.
 */
export default {
  name: 'BandeauTotaux',
  props: {
    libelle: {
      type: String,
      required: true
    },
    // Un total par culture comparee
    valeurs: {
      type: Array,
      default: null
    },
    // Colonnes en cours de recalcul
    hasLoading: {
      type: Array,
      default: () => [false, false, false]
    },
    // Colonnes dont une saisie est en erreur : leur total n'a plus de sens
    hasErreur: {
      type: Array,
      default: () => [false, false, false]
    }
  },
  computed: {
    colonnesVisibles () {
      return this.$vuetify.breakpoint.mobile ? [0, 1] : [0, 1, 2]
    }
  },
  methods: {
    enChargement (colonne) {
      return this.hasLoading[colonne] === true
    },
    valeurAffichee (colonne) {
      const valeur = this.valeurs != null ? this.valeurs[colonne] : null
      // Un total a zero ou une saisie en erreur n'ont rien a montrer : le
      // tiret evite d'afficher un "0" qui passerait pour un resultat.
      // Le filtre roundNumber laisse passer les valeurs non numeriques,
      // le tiret le traverse donc intact.
      if (valeur == null || valeur === 0 || this.hasErreur[colonne]) {
        return '-'
      }
      return valeur
    }
  }
}
</script>
